module.exports = __webpack_public_path__ + "static/HR Smartphone App AbaClik Menü-3fda291786fedaeb43b603a249e1d39d.png";